module.exports = __webpack_public_path__ + "img/canbadge_daishi_115_140mm_line.ae1fd28c.png";